import React from "react";
import "../index.css";
import backgroundUrl from "../../../img/about/crypto-defi-trading-no-slippage-chain-background.svg";
import NoSlippageImg from "../../../img/about/crypto-defi-trading-no-slippage.png";
import { FeatureImage as FeatureImageOriginal } from "./elements/FeatureImage";
import styled from "@emotion/styled";
import { FlexBetweenContainer } from "containers/FlexBetweenContainer";
import { SectionTitle } from "./elements/SectionTitle";
import { SectionContainer } from "./elements/SectionContainer";
import { SectionDescription } from "./elements/SectionDescription";

const TWITTER_URL =
  "https://twitter.com/bebop_dex/status/1541387043015622657?s=20&t=zLVl4A7rBiImegjRSQEkSg";

export interface Feature2Props {
  className?: string;
}

export const Feature2: React.FC<Feature2Props> = () => {
  return (
    <Section>
      <FlexBetweenContainer direction="column">
        <FeatureImage src={NoSlippageImg} alt="feature-2" />
        <SectionTitle>Get the exact price you see, no slippage</SectionTitle>
        <SectionDescription isMarginBottom={true}>
          Trade efficiently with no slippage. The price you see is the price you get and this will
          not change after the trade is initiated.
        </SectionDescription>
        <button
          type="button"
          className="home-btn btn-bebop-outline dark round"
          onClick={() => window.open(TWITTER_URL, "_blank")?.focus()}
        >
          Learn how it’s done
        </button>
      </FlexBetweenContainer>
    </Section>
  );
};

// Sub-components

const Section = styled(SectionContainer)(() => ({
  backgroundImage: `url(${backgroundUrl})`,
  marginTop: "8.8%",

  "@media screen and (min-width: 1280px) and (max-width: 1440px)": {
    marginTop: "148px",
    backgroundSize: "100vw",
  },

  "@media screen and (min-width: 390px) and (max-width: 768px)": {
    backgroundSize: "150vw",
    backgroundPositionX: "center",
    height: "auto",
  },

  "@media screen and (max-width: 390px)": {
    margin: "0",
    height: "auto",
  },
}));

const FeatureImage = styled(FeatureImageOriginal)(() => ({
  width: "33%",
  marginTop: "23%",
  "@media screen and (min-width: 390px) and (max-width: 768px)": {
    marginTop: "45%",
    width: "48%",
  },
  "@media screen and (max-width: 576px)": {
    width: "100%",
  },
}));
